module.exports = __webpack_public_path__ + "static/img/user_2.a3d8d65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_2.png
// module id = V4rf
// module chunks = 0